export const GET = Object.freeze({
  REQUEST: 'maintenanceOperation/GET_REQUEST',
  SUCCESS: 'maintenanceOperation/GET_SUCCESS',
  ERROR: 'maintenanceOperation/GET_ERROR',
});

export const FIND = Object.freeze({
  REQUEST: 'maintenanceOperation/FIND_REQUEST',
  SUCCESS: 'maintenanceOperation/FIND_SUCCESS',
  ERROR: 'maintenanceOperation/FIND_ERROR',
});

export const CREATE = Object.freeze({
  REQUEST: 'maintenanceOperation/CREATE_REQUEST',
  SUCCESS: 'maintenanceOperation/CREATE_SUCCESS',
  ERROR: 'maintenanceOperation/CREATE_ERROR',
});

export const UPDATE = Object.freeze({
  REQUEST: 'maintenanceOperation/UPDATE_REQUEST',
  SUCCESS: 'maintenanceOperation/UPDATE_SUCCESS',
  ERROR: 'maintenanceOperation/UPDATE_ERROR',
});

export const DELETE = Object.freeze({
  REQUEST: 'maintenanceOperation/DELETE_REQUEST',
  SUCCESS: 'maintenanceOperation/DELETE_SUCCESS',
  ERROR: 'maintenanceOperation/DELETE_ERROR',
});

export const RESET_STATE = 'maintenanceOperation/RESET_STATE';

export const GET_MAINTENANCE_OPERATIONS_ACTION = Object.freeze({
  REQUEST: (payload) => ({
    type: GET.REQUEST,
    payload,
  }),
  SUCCESS: (payload) => ({
    type: GET.SUCCESS,
    payload,
    error: false,
  }),
  ERROR: (payload) => ({
    type: GET.ERROR,
    payload,
    error: true,
  }),
});

export const FIND_MAINTENANCE_OPERATION_ACTION = Object.freeze({
  REQUEST: (payload) => ({
    type: FIND.REQUEST,
    payload,
  }),
  SUCCESS: (payload) => ({
    type: FIND.SUCCESS,
    payload,
    error: false,
  }),
  ERROR: (payload) => ({
    type: FIND.ERROR,
    payload,
    error: true,
  }),
});

export const CREATE_MAINTENANCE_OPERATION_ACTION = Object.freeze({
  REQUEST: (payload) => ({
    type: CREATE.REQUEST,
    payload,
  }),
  SUCCESS: (payload) => ({
    type: CREATE.SUCCESS,
    payload,
    error: false,
  }),
  ERROR: (payload) => ({
    type: CREATE.ERROR,
    payload,
    error: true,
  }),
});

export const UPDATE_MAINTENANCE_OPERATION_ACTION = Object.freeze({
  REQUEST: (payload) => ({
    type: UPDATE.REQUEST,
    payload,
  }),
  SUCCESS: (payload) => ({
    type: UPDATE.SUCCESS,
    payload,
    error: false,
  }),
  ERROR: (payload) => ({
    type: UPDATE.ERROR,
    payload,
    error: true,
  }),
});

export const DELETE_MAINTENANCE_OPERATION_ACTION = Object.freeze({
  REQUEST: (payload) => ({
    type: DELETE.REQUEST,
    payload,
  }),
  SUCCESS: (payload) => ({
    type: DELETE.SUCCESS,
    payload,
    error: false,
  }),
  ERROR: (payload) => ({
    type: DELETE.ERROR,
    payload,
    error: true,
  }),
});
